import React, { useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
// import DownloadIcon from '../../../../../../../../designUtils/ProjectDashboard/DownloadIcon.svg';
import DownloadIcon from '../../../../../../../../../../../designUtils/ProjectDashboard/DownloadIcon.svg';

function AmazonListingInfo(props) {
  const [openSections, setOpenSections] = useState({});

  if (!props.data || Object.keys(props.data).length === 0) {
    return <div>No Data Found</div>;
  }
  const downloadExcel = (data) => {
    // flatten object
    const flatData = [];
  
    Object.keys(data).forEach((category) => {
      const fields = data[category];
  
      if (!fields) return;
  
      Object.keys(fields).forEach((key) => {
        const value = fields[key];
  
        // handle array values like condition_type: [{ value: "new_new" }]
        if (Array.isArray(value)) {
          value.forEach((item) => {
            flatData.push({
              category,
              field: key,
              value: item.value
  ? item.value
  : item.media_location
  ? item.media_location
  : JSON.stringify(item)
            });
          });
        } else {
          flatData.push({
            category,
            field: key,
            value:
              typeof value === "object"
                ? JSON.stringify(value)
                : value,
          });
        }
      });
    });
  
    // convert to sheet
    const worksheet = XLSX.utils.json_to_sheet(flatData);
    const workbook = XLSX.utils.book_new();
  
    XLSX.utils.book_append_sheet(workbook, worksheet, "AmazonData");
  
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
  
    const file = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
  
    saveAs(file,  `${props.childProductData ? props.childProductData.productTitle : ''}.xlsx`);
  };
  

  const IGNORE_KEYS = ["language_tag", "marketplace_id"];

  const toggleSection = function (key) {
    setOpenSections(function (prev) {
      return {
        ...prev,
        [key]: !prev[key],
      };
    });
  };

  const formatKey = function (key) {
    return key.replace(/_/g, " ");
  };

  // Render image grid (3 images per row)
  const renderImageGrid = function (imagesObj) {
    var images = [];

    Object.keys(imagesObj).forEach(function (key) {
      var arr = imagesObj[key];

      if (Array.isArray(arr)) {
        arr.forEach(function (item) {
          if (item && item.media_location) {
            images.push({
              name: formatKey(key),
              url: item.media_location,
            });
          }
        });
      }
    });

    return (
      <div>
         

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "20px",
          }}
        >
          {images.map(function (img, index) {
            return (
              <div
                key={index}
                style={{
                  textAlign: "center",
                  border: "1px solid #ddd",
                  borderRadius: "5px",
                  padding: "10px",
                  background: "#fff",
                }}
              >
                <img
                  src={img.url}
                  alt={img.name}
                  style={{
                    width: "180px",
                    height: "180px",
                    objectFit: "contain",
                    marginBottom: "10px",
                  }}
                />

                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "13px",
                    wordBreak: "break-word",
                  }}
                >
                  {img.name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderData = function (data) {
    if (data === null || data === undefined) {
      return "-";
    }

    if (
      typeof data === "string" ||
      typeof data === "number" ||
      typeof data === "boolean"
    ) {
      return data.toString();
    }

    if (Array.isArray(data)) {
      return (
        <div>
          {data.map(function (item, index) {
            return (
              <div key={index} style={{ marginBottom: "6px" }}>
                {renderData(item)}
              </div>
            );
          })}
        </div>
      );
    }

    if (data.media_location) {
      return (
        <img
          src={data.media_location}
          alt=""
          style={{
            width: "120px",
            height: "120px",
            objectFit: "contain",
            border: "1px solid #ddd",
          }}
        />
      );
    }

    return (
      <div>
        {Object.keys(data)
          .filter(function (k) {
            return IGNORE_KEYS.indexOf(k) === -1;
          })
          .map(function (key) {
            var value = data[key];

            return (
              <div key={key} style={{ marginBottom: "5px" }}>
                <strong>{formatKey(key)} :</strong>{" "}
                {typeof value === "object"
                  ? renderData(value)
                  : value === null
                  ? "-"
                  : value.toString()}
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center mb-3">
         <h5 style={{ marginBottom: "20px" }}>
            {props.childProductData?props.childProductData.productTitle:''}
          </h5>
          <img
          src={DownloadIcon}
          onClick={() => downloadExcel(props.data)}
          alt="Download"
            height={20}
            width={20}
            style={{ cursor: 'pointer' }}
            title="Download"
          />
          </div>
        
      {Object.keys(props.data).map(function (category) {
        var fields = props.data[category];

        if (!fields) return null;

        var isOpen = openSections[category];

        return (
          <div
            key={category}
            style={{
              border: "1px solid #ddd",
              marginBottom: "20px",
            }}
          >
            <div
              onClick={function () {
                toggleSection(category);
              }}
              style={{
                cursor: "pointer",
                padding: "10px",
                background: "#f3f3f3",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              {formatKey(category).toUpperCase()}
              <span style={{ float: "right" }}>
                {isOpen ? "▲" : "▼"}
              </span>
            </div>

            {isOpen && (
              <>
                {category === "images" ? (
                  <div style={{ padding: "20px" }}>
                    {renderImageGrid(fields)}
                  </div>
                ) : (
                  <table
                    className="table table-bordered"
                    style={{ marginBottom: 0 }}
                  >
                    <tbody>
                      {Object.keys(fields).map(function (fieldKey) {
                        return (
                          <tr key={fieldKey}>
                            <td
                              style={{
                                width: "30px",
                                fontWeight: "bold",
                                background: "#fafafa",
                                verticalAlign: "top",
                              }}
                            >
                              {formatKey(fieldKey)}
                            </td>

                            <td>{renderData(fields[fieldKey])}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default AmazonListingInfo;